import api from '../api/events'

const state = {
  // eventsList: [],
  eventDetails: {},
  eventImages: [],
  error: null
}

const getters = {
  eventDetails: state => state.eventDetails,
  eventImages: state => state.eventImages
  // eventsList: state => state.eventsList
}

const actions = {
  getRecord({ commit }, id) {
    return new Promise((resolve, reject) => {
      api
        .fetchEventDetails(id)
        .then(response => {
          commit('SET_EVENT_DETAILS', response.data)
          resolve(response.data)
        })
        .catch(error => {
          commit('SET_ERROR', error)
          reject(error)
        })
    })
  },
  getImages({ commit }, id) {
    return new Promise((resolve, reject) => {
      api
        .fetchEventImages(id)
        .then(response => {
          commit('SET_EVENT_IMAGES', response.data)
          resolve(response.data)
        })
        .catch(error => {
          commit('SET_ERROR', error)
          reject(error)
        })
    })
  },
  // getApprovedEvents({ commit }, id) {
  //   return new Promise((resolve, reject) => {
  //     api.fetchApprovedEvents(id)
  //       .then(response => {
  //         commit('SET_EVENTS', response.data.data)
  //         commit('SET_CURRENT_EVENT', 0)
  //         resolve()
  //       })
  //       .catch(error => {
  //         commit('SET_ERROR', error)
  //         reject(error)
  //       })
  //   })
  // },
  saveEvent({ commit }, model) {
    return new Promise((resolve, reject) => {
      api
        .putEvent(model)
        .then(response => {
          resolve()
        })
        .catch(error => {
          commit('SET_ERROR', error)
          reject(error)
        })
    })
  }
}

const mutations = {
  // SET_EVENTS(state, events) {
  //   events.sort((a, b) => {
  //     return (new Date(a.ts) - new Date(b.ts))
  //   })

  //   state.eventsList = events.reverse()
  //   // TODO: get this fixed in the API
  // },
  SET_EVENT_DETAILS(state, event) {
    state.eventDetails = event
  },
  SET_EVENT_IMAGES(state, images) {
    state.eventImages = images
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
